import React from 'react';

const STATE_META = {
  draft_scope:          { label: 'Draft Scope',      group: 'scope'  },
  scope_review:         { label: 'Scope Review',     group: 'scope'  },
  ready_for_rfq:        { label: 'Ready for RFQ',   group: 'scope'  },
  rfq_drafted:          { label: 'RFQ Drafted',      group: 'rfq'    },
  rfq_approved:         { label: 'RFQ Approved',     group: 'rfq'    },
  rfq_sent:             { label: 'RFQ Sent',         group: 'rfq'    },
  awaiting_quotes:      { label: 'Awaiting Quotes',  group: 'quotes' },
  quotes_received:      { label: 'Quotes Received',  group: 'quotes' },
  bid_leveling:         { label: 'Bid Leveling',     group: 'award'  },
  award_recommendation: { label: 'Recommendation',   group: 'award'  },
  award_approved:       { label: 'Awarded',          group: 'award'  },
  contract_po_pending:  { label: 'Contract Pending', group: 'post'   },
  contract_po_issued:   { label: 'Contract Issued',  group: 'post'   },
  submittals_pending:   { label: 'Submittals',       group: 'post'   },
  submittals_approved:  { label: 'Sub. Approved',    group: 'post'   },
  delivery_scheduled:   { label: 'Delivery Sched.',  group: 'post'   },
  delivered:            { label: 'Delivered',        group: 'post'   },
  invoice_pending:      { label: 'Invoice Pending',  group: 'post'   },
  invoice_matched:      { label: 'Invoice Matched',  group: 'post'   },
  closed:               { label: 'Closed',           group: 'closed' },
  // Legacy states
  draft:                { label: 'Draft',            group: 'scope'  },
  rfq_sent_legacy:      { label: 'RFQ Sent',         group: 'rfq'    },
  comparing:            { label: 'Comparing',        group: 'quotes' },
  awarded:              { label: 'Awarded',          group: 'award'  },
};

const GROUP_STYLES = {
  scope:  { bg: '#F1F5F9', color: '#64748B' },
  rfq:    { bg: '#EFF6FF', color: '#3B82F6' },
  quotes: { bg: '#F5F3FF', color: '#8B5CF6' },
  award:  { bg: '#ECFDF5', color: '#059669' },
  post:   { bg: '#CCFBF1', color: '#0D9488' },
  closed: { bg: '#0F172A', color: '#fff'    },
};

export default function LifecyclePill({ state, size = 'sm' }) {
  const meta = STATE_META[state] || { label: state || 'Draft', group: 'scope' };
  const style = GROUP_STYLES[meta.group] || GROUP_STYLES.scope;
  const padding = size === 'lg' ? '4px 12px' : '3px 8px';
  const fontSize = size === 'lg' ? '0.8125rem' : '0.6875rem';

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      padding, borderRadius: 'var(--radius-full)',
      fontSize, fontWeight: 600, letterSpacing: '0.03em',
      textTransform: 'uppercase',
      background: style.bg, color: style.color,
      whiteSpace: 'nowrap',
    }}>
      {meta.label}
    </span>
  );
}

export { STATE_META, GROUP_STYLES };